// @flow
import { combineActions, handleActions } from 'redux-actions';

import { upsertResource, upsertResources } from 'data/qcsSyncResourceReducerHelpers';

import * as actions from './actions';
import { mkRulesStore } from './types';

const reducer = handleActions({

  // Called when triggering a CRUD operation on transactions. Sagas are also
  // expected to handle the action by initiating the CRUD operation with QCS.
  //
  [combineActions(
    actions.getRules,
    actions.createRule,
    actions.updateRule,
    actions.deleteRule
  )]: (state) => state,

  // Called when a CRUD operation is successful on transactions. The success
  // action is triggered by the Sagas.
  [combineActions(
    actions.getRulesSuccess
  )]:
    (state, { payload: data }) => upsertResources(state, data),

  // Called when a CRUD operation is successful on transactions. The success
  // action is triggered by the Sagas.
  [combineActions(
    actions.createRuleSuccess,
    actions.updateRuleSuccess,
    actions.deleteRuleSuccess
  )]:
    (state, { payload: ruleToUpsert }) =>
      upsertResource(state, ruleToUpsert),

  // Called when a CRUD operation fails on transactions. The failure action
  // is triggered by Sagas.
  [combineActions(
    actions.getRulesFailure,
    actions.createRuleFailure,
    actions.updateRuleFailure,
    actions.deleteRuleFailure
  )]:
    (state, { payload: _error }) =>
      // todo: what else should we do with the failure?
      state,

}, mkRulesStore());

export const REDUCER_KEY = 'ruleStore';
export default reducer;
